// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"b6eb0580","189":"de9d7bb6","328":"ef384ef9","421":"21c2c301","632":"b6eb0580","691":"b613f144","724":"cc00fa56"}[chunkId] + ".chunk.css";
};